var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Chip, Drawer, Grid, TextField, useMediaQuery } from '@mui/material';
import { debounce } from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { t } from 'i18next';
import * as React from 'react';
import { ComplaintGroupBasedOnIdURL, ComplaintGroupURL, ComplaintsJobItemsSearchURL, getDeclinedCustomerComplaintsUrl, getSavedJobItemsUrl, translateToJobDownloadAttchementURl } from '../../../api/url';
import { CrossIcon, SearchIcon } from '../../../assets/images';
import { downloadAttachment, showLoader } from '../../../redux/commonSlice';
import { getByIdAPI, getListAPI } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { MuiBox } from '../../atoms/boxComponent';
import { MuiButton } from '../../atoms/buttonComponent';
import { MuiIconButton } from '../../atoms/iconButtonComponent';
import { MuiStack } from '../../atoms/stackComponent';
import Loader from '../../molecules/loader';
import { PageHeading } from '../../molecules/pageHeading';
import { CheckBoxComponent } from './checkBoxSelection';
import { MuiLoaderButton } from '../../atoms/loaderButton';
import { sortImagesByTimeStamp } from '../../../utils/utils';
import { useCallback } from 'react';
import JobItemsLoader from '../../atoms/jobItemsLoader';
var Accordion = styled(function (props) { /*#__PURE__*/ return React.createElement(MuiAccordion, _extends({
    disableGutters: true,
    elevation: 0,
    square: true
}, props)); })(function (_ref) {
    var theme = _ref.theme;
    return {
        border: "1px solid ".concat(theme.palette.divider),
        '&:not(:last-child)': {
            borderBottom: 0
        },
        '&:before': {
            display: 'none'
        }
    };
});
var DrawerHeader = styled('div')(function (_ref2) {
    var theme = _ref2.theme;
    return _objectSpread({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: theme.spacing(0, 2)
    }, theme.mixins.toolbar);
});
export default function TranslateToJobComponent(props) {
    var _this = this;
    var isOpen = props.isOpen, onClose = props.onClose, isDisabled = props.isDisabled, filterSystemName = props.filterSystemName, vehicleList = props.vehicleList, requestID = props.requestID;
    var dispatch = useAppDispatch();
    var _a = React.useState(null), expanded = _a[0], setExpanded = _a[1];
    var _b = React.useState([]), listValue = _b[0], setListValue = _b[1];
    var _c = React.useState(""), searchValue = _c[0], setSearchValue = _c[1];
    var _d = React.useState([]), listComplant = _d[0], setListComplant = _d[1];
    var _e = React.useState(false), isSaveDisbale = _e[0], setIsSaveDisbale = _e[1];
    var isLoaderOpen = useAppSelector(function (state) { return state.common.isLoader; }).isLoaderOpen;
    var _f = React.useState([]), savedJobItemsAgainsComplaint = _f[0], setSavedJobItemsAgainsCompalint = _f[1];
    var _g = useAppSelector(function (state) { return state.crud; }), documentDetailsGetById = _g.documentDetailsGetById, ModuleDetailsGetById = _g.ModuleDetailsGetById, getStoredJobItems = _g.getStoredJobItems, preDocumentFetch = _g.preDocumentFetch, savedJobItemCreateFlow = _g.savedJobItemCreateFlow;
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var islgmode = useMediaQuery(function (theme) { return theme.breakpoints.up('md'); });
    var _h = React.useState([]), declinedComplaints = _h[0], setDeclinedComplaints = _h[1];
    var _j = React.useState([]), searchResult = _j[0], setSearchResult = _j[1];
    var _k = React.useState([]), complaintsGroupsList = _k[0], setComplaintsGroupsList = _k[1];
    var _l = React.useState(false), showSkeleton = _l[0], setShowSkeleton = _l[1];
    var customerDetailsTrnalsteToJob = useAppSelector(function (state) { return state.crud; }).customerDetailsTrnalsteToJob;
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    React.useEffect(function () {
        if (isOpen) {
            var _preDocumentFetch$dat;
            getTranslateToJobItems();
            if (requestID || preDocumentFetch && preDocumentFetch !== null && preDocumentFetch !== void 0 && preDocumentFetch.data && Array.isArray(preDocumentFetch === null || preDocumentFetch === void 0 ? void 0 : preDocumentFetch.data) && (preDocumentFetch === null || preDocumentFetch === void 0 ? void 0 : preDocumentFetch.data.length) > 0 && preDocumentFetch !== null && preDocumentFetch !== void 0 && (_preDocumentFetch$dat = preDocumentFetch.data[0]) !== null && _preDocumentFetch$dat !== void 0 && _preDocumentFetch$dat.PreJobCardDocumentId) {
                getDeclinedJobItems();
            }
        }
    }, [isOpen]);
    var handleSearchChange = function (event) {
        // setSearchText(event.target.value);
        if (event.target.value.length > 2) {
            getSearchResult(event.target.value);
        }
    };
    var sendRequest = useCallback(function (value) {
        handleSearchChange(value);
    }, [complaintsGroupsList.length > 0]);
    // memoize the debounce call with useMemo
    var debouncedSendRequest = React.useMemo(function () {
        return debounce(sendRequest, 500);
    }, [sendRequest]);
    var getDeclinedJobItems = function () { return __awaiter(_this, void 0, void 0, function () {
        var _preDocumentFetch$dat2, _documentDetailsGetBy, _documentDetailsGetBy2, declinedRequestBody, getDeclinedCustomerResponse, declinedItems;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    declinedRequestBody = {
                        ParentId: requestID || (preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat2 = preDocumentFetch.data[0]) === null || _preDocumentFetch$dat2 === void 0 ? void 0 : _preDocumentFetch$dat2.PreJobCardDocumentId),
                        OrganizationId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy = documentDetailsGetById.data) === null || _documentDetailsGetBy === void 0 ? void 0 : _documentDetailsGetBy.OrganizationId,
                        VinNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy2 = documentDetailsGetById.data) === null || _documentDetailsGetBy2 === void 0 ? void 0 : _documentDetailsGetBy2.VinNo
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: getDeclinedCustomerComplaintsUrl,
                            request: declinedRequestBody
                        }))];
                case 1:
                    getDeclinedCustomerResponse = _a.sent();
                    declinedItems = [];
                    if (getDeclinedCustomerResponse && getDeclinedCustomerResponse.payload.success && getDeclinedCustomerResponse.payload.data) {
                        declinedItems = getDeclinedCustomerResponse.payload.data;
                    }
                    setDeclinedComplaints(declinedItems);
                    return [2 /*return*/];
            }
        });
    }); };
    var checkSavedComplaints = function (JobItems, groups) {
        var SavedJobItems = customerDetailsTrnalsteToJob === null || customerDetailsTrnalsteToJob === void 0 ? void 0 : customerDetailsTrnalsteToJob.data;
        var countMap = {};
        if (SavedJobItems) {
            var updatedSavedJobItems_1 = [];
            SavedJobItems.forEach(function (item) {
                var complaintGroupId = item.ComplaintGroupId;
                countMap[complaintGroupId] = (countMap[complaintGroupId] || 0) + 1;
                updatedSavedJobItems_1.push(_objectSpread(_objectSpread({}, item), {}, {
                    isCheckBoxClicked: true,
                    isAlreadySaved: true
                }));
            });
            setSavedJobItemsAgainsCompalint(updatedSavedJobItems_1);
        }
        var resultArray = groups.map(function (item) {
            var count = countMap[item.id];
            return _objectSpread(_objectSpread({}, item), {}, {
                selectedValueCount: count || 0,
                isSkeletonVisible: true
            });
        });
        setListValue(resultArray);
    };
    var getTranslateToJobItems = function () { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy3, _ModuleDetailsGetById, _result$payload, _result$payload2, productID, complaintRequest, result, _result$payload3, _preDocumentFetch$dat3, groups, groupsSortedByAlphabeticalOrder, updatedSavedJobItems_2, countMap_1, resultArray, requestBody, _SavedJobItemsRespons, _SavedJobItemsRespons2, SavedJobItemsResponse, _SavedJobItemsRespons3, resultArray;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setShowSkeleton(true);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    productID = documentDetailsGetById !== null && documentDetailsGetById !== void 0 && documentDetailsGetById.data ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy3 = documentDetailsGetById.data) === null || _documentDetailsGetBy3 === void 0 ? void 0 : _documentDetailsGetBy3.ProductId : ModuleDetailsGetById !== null && ModuleDetailsGetById !== void 0 && ModuleDetailsGetById.data ? ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById === void 0 ? void 0 : _ModuleDetailsGetById.ProductId : vehicleList === null || vehicleList === void 0 ? void 0 : vehicleList.ProductId;
                    complaintRequest = {
                        ProductId: productID
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'ComplaintGroupList',
                            url: ComplaintGroupURL,
                            request: complaintRequest
                        }))];
                case 2:
                    result = _a.sent();
                    if (!(result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.success && result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.data)) return [3 /*break*/, 10];
                    groups = __spreadArray([], (result === null || result === void 0 || (_result$payload3 = result.payload) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.value) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.data), true);
                    groupsSortedByAlphabeticalOrder = groups.sort(function (a, b) {
                        if ((a === null || a === void 0 ? void 0 : a.DisplayName) < (b === null || b === void 0 ? void 0 : b.DisplayName)) {
                            return -1;
                        }
                        if ((a === null || a === void 0 ? void 0 : a.DisplayName) > (b === null || b === void 0 ? void 0 : b.DisplayName)) {
                            return 1;
                        }
                        return 0;
                    });
                    setComplaintsGroupsList(groupsSortedByAlphabeticalOrder);
                    if (!(getStoredJobItems.length > 0 || savedJobItemCreateFlow)) return [3 /*break*/, 3];
                    updatedSavedJobItems_2 = [];
                    countMap_1 = {};
                    getStoredJobItems.forEach(function (item) {
                        var complaintGroupId = item.ComplaintGroupId;
                        countMap_1[complaintGroupId] = (countMap_1[complaintGroupId] || 0) + 1;
                        updatedSavedJobItems_2.push(_objectSpread(_objectSpread({}, item), {}, {
                            isCheckBoxClicked: true,
                            isAlreadySaved: true
                        }));
                    });
                    resultArray = groupsSortedByAlphabeticalOrder.map(function (item) {
                        var count = countMap_1[item.id];
                        return _objectSpread(_objectSpread({}, item), {}, {
                            selectedValueCount: count || 0,
                            isSkeletonVisible: true
                        });
                    });
                    setListValue(resultArray);
                    setSavedJobItemsAgainsCompalint(updatedSavedJobItems_2);
                    return [3 /*break*/, 8];
                case 3:
                    if (!(requestID || (preDocumentFetch === null || preDocumentFetch === void 0 || (_preDocumentFetch$dat3 = preDocumentFetch.data) === null || _preDocumentFetch$dat3 === void 0 ? void 0 : _preDocumentFetch$dat3.length) > 0)) return [3 /*break*/, 7];
                    requestBody = {
                        PreJobCardDocumentId: requestID || (preDocumentFetch === null || preDocumentFetch === void 0 ? void 0 : preDocumentFetch.data[0].PreJobCardDocumentId)
                    };
                    if (!(customerDetailsTrnalsteToJob && customerDetailsTrnalsteToJob.success && customerDetailsTrnalsteToJob.data)) return [3 /*break*/, 4];
                    checkSavedComplaints(customerDetailsTrnalsteToJob === null || customerDetailsTrnalsteToJob === void 0 ? void 0 : customerDetailsTrnalsteToJob.data, groupsSortedByAlphabeticalOrder);
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: 'customerDetailsTrnalsteToJob',
                        url: getSavedJobItemsUrl,
                        request: requestBody
                    }))];
                case 5:
                    SavedJobItemsResponse = _a.sent();
                    if ((_SavedJobItemsRespons = SavedJobItemsResponse.payload.value) !== null && _SavedJobItemsRespons !== void 0 && _SavedJobItemsRespons.success && (_SavedJobItemsRespons2 = SavedJobItemsResponse.payload.value) !== null && _SavedJobItemsRespons2 !== void 0 && _SavedJobItemsRespons2.data) {
                        checkSavedComplaints((_SavedJobItemsRespons3 = SavedJobItemsResponse.payload.value) === null || _SavedJobItemsRespons3 === void 0 ? void 0 : _SavedJobItemsRespons3.data, groupsSortedByAlphabeticalOrder);
                    }
                    _a.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    resultArray = groupsSortedByAlphabeticalOrder.map(function (item) {
                        return _objectSpread(_objectSpread({}, item), {}, {
                            selectedValueCount: 0,
                            isSkeletonVisible: true
                        });
                    });
                    setListValue(resultArray);
                    _a.label = 8;
                case 8:
                    setShowSkeleton(false);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 9:
                    _a.sent();
                    return [3 /*break*/, 12];
                case 10:
                    setShowSkeleton(false);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 11:
                    _a.sent();
                    _a.label = 12;
                case 12: return [2 /*return*/];
            }
        });
    }); };
    var getJobListByComplaintGrpId = function (groupItem) { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy4, _ModuleDetailsGetById2, _result$payload4, _result$payload5, productID, requestBody, result, _result$payload6, jobItemsByComplaintGroup;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    productID = documentDetailsGetById !== null && documentDetailsGetById !== void 0 && documentDetailsGetById.data ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy4 = documentDetailsGetById.data) === null || _documentDetailsGetBy4 === void 0 ? void 0 : _documentDetailsGetBy4.ProductId : ModuleDetailsGetById !== null && ModuleDetailsGetById !== void 0 && ModuleDetailsGetById.data ? ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById2 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById2 === void 0 ? void 0 : _ModuleDetailsGetById2.ProductId : vehicleList === null || vehicleList === void 0 ? void 0 : vehicleList.ProductId;
                    requestBody = {
                        ComplaintGroupId: groupItem,
                        ProductId: productID
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'ComplaintGroupBasedOnIdList',
                            url: ComplaintGroupBasedOnIdURL,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload4 = result.payload) !== null && _result$payload4 !== void 0 && (_result$payload4 = _result$payload4.value) !== null && _result$payload4 !== void 0 && _result$payload4.success && result !== null && result !== void 0 && (_result$payload5 = result.payload) !== null && _result$payload5 !== void 0 && (_result$payload5 = _result$payload5.value) !== null && _result$payload5 !== void 0 && _result$payload5.data) {
                        jobItemsByComplaintGroup = __spreadArray([], (result === null || result === void 0 || (_result$payload6 = result.payload) === null || _result$payload6 === void 0 || (_result$payload6 = _result$payload6.value) === null || _result$payload6 === void 0 ? void 0 : _result$payload6.data), true);
                        //(a: any, b: any) => a.ComplaintName.localeCompare(b.ComplaintName));
                        return [2 /*return*/, jobItemsByComplaintGroup];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (panel) { return function (event, newExpanded) {
        setExpanded(newExpanded ? panel : null);
    }; };
    var handleCheckBoxClick = function (list, groupName) {
        var finalValue = listValue === null || listValue === void 0 ? void 0 : listValue.map(function (item) {
            if (item.Name === groupName) {
                return _objectSpread(_objectSpread({}, item), {}, {
                    data: list
                });
            }
            else {
                return item;
            }
        });
        var selectedValueCount = list.filter(function (item) { return item.isCheckBoxClicked == true; });
        var finalList = finalValue === null || finalValue === void 0 ? void 0 : finalValue.map(function (item) { return item.Name === groupName && selectedValueCount ? _objectSpread({}, item) : item; });
        if (finalList) {
            setListValue(finalList);
        }
        setIsSaveDisbale(true);
        //dispatch(setIsTaskDetailsDataUpdated(true))
    };
    var onChange = function (event) {
        var searchTerm = event.target.value;
        setSearchValue(searchTerm);
        debouncedSendRequest(event);
    };
    var getSearchResult = function (searchTerm) { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy5, _ModuleDetailsGetById3, _searchResponse$paylo, _searchResponse$paylo2, productID, searchJobRequestBody, searchResponse, _searchResponse$paylo3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
                case 1:
                    _a.sent();
                    productID = documentDetailsGetById !== null && documentDetailsGetById !== void 0 && documentDetailsGetById.data ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy5 = documentDetailsGetById.data) === null || _documentDetailsGetBy5 === void 0 ? void 0 : _documentDetailsGetBy5.ProductId : ModuleDetailsGetById !== null && ModuleDetailsGetById !== void 0 && ModuleDetailsGetById.data ? ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById3 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById3 === void 0 ? void 0 : _ModuleDetailsGetById3.ProductId : vehicleList === null || vehicleList === void 0 ? void 0 : vehicleList.ProductId;
                    searchJobRequestBody = {
                        ProductId: productID,
                        Keyword: searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toLocaleLowerCase(),
                        ComplaintGroupIds: complaintsGroupsList.map(function (item) { return item.id; })
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: ComplaintsJobItemsSearchURL,
                            request: searchJobRequestBody
                        }))];
                case 2:
                    searchResponse = _a.sent();
                    if ((_searchResponse$paylo = searchResponse.payload) !== null && _searchResponse$paylo !== void 0 && (_searchResponse$paylo = _searchResponse$paylo.value) !== null && _searchResponse$paylo !== void 0 && _searchResponse$paylo.success && (_searchResponse$paylo2 = searchResponse.payload) !== null && _searchResponse$paylo2 !== void 0 && (_searchResponse$paylo2 = _searchResponse$paylo2.value) !== null && _searchResponse$paylo2 !== void 0 && _searchResponse$paylo2.data) {
                        setSearchResult((_searchResponse$paylo3 = searchResponse.payload) === null || _searchResponse$paylo3 === void 0 || (_searchResponse$paylo3 = _searchResponse$paylo3.value) === null || _searchResponse$paylo3 === void 0 ? void 0 : _searchResponse$paylo3.data);
                    }
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleComplaintData = function (data) {
        setListComplant(__spreadArray(__spreadArray([], listComplant, true), [data], false));
    };
    var handleClose = function () {
        setSearchValue("");
        onClose();
    };
    var handleSave = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setSearchValue("");
            // props.onClose()
            if (listValue) {
                props.handleSave(listValue, declinedComplaints);
            }
            return [2 /*return*/];
        });
    }); };
    var handleAccordian = function (id, index, expanded) { return __awaiter(_this, void 0, void 0, function () {
        var _selectedAccordianGro, updatedListValue, selectedAccordianGroupItem, res, _selectedAccordianGro2, ReplaceJobItemsForGroup_1, loopPromiose, jobItemsByComplaintGroupByAlphabeticalOrder;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedListValue = __spreadArray([], listValue, true);
                    selectedAccordianGroupItem = _objectSpread({}, updatedListValue[index]);
                    if (selectedAccordianGroupItem.data || loader.isLoaderOpen) {
                        return [2 /*return*/];
                    }
                    // let groups = ComplaintGroupList
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    // let groups = ComplaintGroupList
                    _a.sent();
                    return [4 /*yield*/, getJobListByComplaintGrpId(id)];
                case 2:
                    res = _a.sent();
                    selectedAccordianGroupItem.data = res;
                    if (!((selectedAccordianGroupItem === null || selectedAccordianGroupItem === void 0 || (_selectedAccordianGro = selectedAccordianGroupItem.data) === null || _selectedAccordianGro === void 0 ? void 0 : _selectedAccordianGro.length) > 0)) return [3 /*break*/, 4];
                    ReplaceJobItemsForGroup_1 = [];
                    loopPromiose = (_selectedAccordianGro2 = selectedAccordianGroupItem.data) === null || _selectedAccordianGro2 === void 0 ? void 0 : _selectedAccordianGro2.map(function (accordianItem) { return __awaiter(_this, void 0, void 0, function () {
                        var matchingItem, _matchingItem, _matchingItem2, _audioAttachementURLs, _audioAttachementURLs2, _audioAttachementURLs3, _audioAttachementURLs4, _audioAttachementURLs5, _audioAttachementURLs6, imageAttachementURLs_1, audioAttachementURLs, imageAttachmentsUrlWithMediaType1, audioAttachmentsUrlWithMediaType2, downloadImagePromise, downloadAudioPromise, sortedImages;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    matchingItem = savedJobItemsAgainsComplaint === null || savedJobItemsAgainsComplaint === void 0 ? void 0 : savedJobItemsAgainsComplaint.find(function (jobItem) { return accordianItem.ComplaintId === jobItem.ComplaintId; });
                                    if (!matchingItem) return [3 /*break*/, 4];
                                    matchingItem = _objectSpread({}, matchingItem);
                                    if (!(matchingItem && (_matchingItem = matchingItem) !== null && _matchingItem !== void 0 && _matchingItem.ImageAttachments && ((_matchingItem2 = matchingItem) === null || _matchingItem2 === void 0 || (_matchingItem2 = _matchingItem2.ImageAttachments) === null || _matchingItem2 === void 0 ? void 0 : _matchingItem2.length) > 0)) return [3 /*break*/, 3];
                                    imageAttachementURLs_1 = [];
                                    audioAttachementURLs = [];
                                    imageAttachmentsUrlWithMediaType1 = matchingItem.ImageAttachments.filter(function (item) { return item.MediaType === 1; });
                                    audioAttachmentsUrlWithMediaType2 = matchingItem.ImageAttachments.filter(function (item) { return item.MediaType === 2; });
                                    downloadImagePromise = imageAttachmentsUrlWithMediaType1.map(function (imageItem) { return __awaiter(_this, void 0, void 0, function () {
                                        var _imageItem$isNewImage, base64, error_1;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!imageItem.AttachmentId) return [3 /*break*/, 4];
                                                    _a.label = 1;
                                                case 1:
                                                    _a.trys.push([1, 3, , 4]);
                                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, matchingItem.ComplaintId, translateToJobDownloadAttchementURl)];
                                                case 2:
                                                    base64 = _a.sent();
                                                    imageAttachementURLs_1.push({
                                                        blobUrl: base64,
                                                        attachmentId: imageItem.AttachmentId,
                                                        isAlreadyUploaded: true,
                                                        _ts: imageItem._ts,
                                                        isNewImageUploaded: (_imageItem$isNewImage = imageItem.isNewImageUploaded) !== null && _imageItem$isNewImage !== void 0 ? _imageItem$isNewImage : false
                                                    });
                                                    return [3 /*break*/, 4];
                                                case 3:
                                                    error_1 = _a.sent();
                                                    console.error("error", error_1);
                                                    return [3 /*break*/, 4];
                                                case 4: return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                    downloadAudioPromise = audioAttachmentsUrlWithMediaType2.map(function (imageItem) { return __awaiter(_this, void 0, void 0, function () {
                                        var base64, error_2;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!imageItem.AttachmentId) return [3 /*break*/, 4];
                                                    _a.label = 1;
                                                case 1:
                                                    _a.trys.push([1, 3, , 4]);
                                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, matchingItem.ComplaintId, translateToJobDownloadAttchementURl)];
                                                case 2:
                                                    base64 = _a.sent();
                                                    audioAttachementURLs.push({
                                                        audioUrl: base64,
                                                        AttachmentId: imageItem.AttachmentId,
                                                        isAlreadyUploaded: true
                                                    });
                                                    return [3 /*break*/, 4];
                                                case 3:
                                                    error_2 = _a.sent();
                                                    console.error("error", error_2);
                                                    return [3 /*break*/, 4];
                                                case 4: return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                    return [4 /*yield*/, Promise.all(downloadImagePromise)];
                                case 1:
                                    _a.sent();
                                    return [4 /*yield*/, Promise.all(downloadAudioPromise)];
                                case 2:
                                    _a.sent();
                                    sortedImages = sortImagesByTimeStamp(imageAttachementURLs_1);
                                    matchingItem.images = sortedImages;
                                    matchingItem.audioUrl = (_audioAttachementURLs = (_audioAttachementURLs2 = audioAttachementURLs[0]) === null || _audioAttachementURLs2 === void 0 ? void 0 : _audioAttachementURLs2.audioUrl) !== null && _audioAttachementURLs !== void 0 ? _audioAttachementURLs : "";
                                    matchingItem.audioAttachmentId = (_audioAttachementURLs3 = (_audioAttachementURLs4 = audioAttachementURLs[0]) === null || _audioAttachementURLs4 === void 0 ? void 0 : _audioAttachementURLs4.AttachmentId) !== null && _audioAttachementURLs3 !== void 0 ? _audioAttachementURLs3 : "";
                                    matchingItem.isAudioAlreadyUploaded = (_audioAttachementURLs5 = (_audioAttachementURLs6 = audioAttachementURLs[0]) === null || _audioAttachementURLs6 === void 0 ? void 0 : _audioAttachementURLs6.isAlreadyUploaded) !== null && _audioAttachementURLs5 !== void 0 ? _audioAttachementURLs5 : false;
                                    matchingItem.isCheckBoxClicked = true;
                                    matchingItem.selectedValueCount = accordianItem.selectedValueCount;
                                    _a.label = 3;
                                case 3:
                                    matchingItem.ComplaintChildAssociation = accordianItem.ComplaintChildAssociation;
                                    ReplaceJobItemsForGroup_1.push(matchingItem);
                                    return [3 /*break*/, 5];
                                case 4:
                                    ReplaceJobItemsForGroup_1.push(accordianItem);
                                    _a.label = 5;
                                case 5: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(loopPromiose)];
                case 3:
                    _a.sent();
                    jobItemsByComplaintGroupByAlphabeticalOrder = ReplaceJobItemsForGroup_1.sort(function (a, b) {
                        if ((a === null || a === void 0 ? void 0 : a.ComplaintName) < (b === null || b === void 0 ? void 0 : b.ComplaintName)) {
                            return -1;
                        }
                        if ((a === null || a === void 0 ? void 0 : a.ComplaintName) > (b === null || b === void 0 ? void 0 : b.ComplaintName)) {
                            return 1;
                        }
                        return 0;
                    });
                    selectedAccordianGroupItem.data = jobItemsByComplaintGroupByAlphabeticalOrder;
                    _a.label = 4;
                case 4:
                    selectedAccordianGroupItem.isSkeletonVisible = false;
                    updatedListValue[index] = selectedAccordianGroupItem;
                    setListValue(updatedListValue);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 5:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return /*#__PURE__*/ React.createElement(Drawer, {
        id: "translate-to-job-drawer",
        anchor: "right",
        open: isOpen,
        onClose: handleClose,
        sx: {
            display: {
                xs: 'block',
                sm: 'block',
                md: 'block',
                lg: 'block'
            },
            '& .MuiDrawer-paper': {
                width: {
                    xs: '100%',
                    sm: '50%',
                    md: '40%',
                    lg: '35%',
                    xl: '35%'
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, islgmode && /*#__PURE__*/ React.createElement(DrawerHeader, null), /*#__PURE__*/ React.createElement(PageHeading, {
        sx: {
            paddingX: {
                lg: "16px"
            }
        }
    }, /*#__PURE__*/ React.createElement(MuiBox, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'white',
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 11,
        style: {
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: 'lg',
            fontWeight: 'strong',
            color: 'text.primary'
        },
        id: "trasnlateToJobItems",
        align: "left"
    }, t("TRANSLATE_TO_JOB_ITEM"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 1
    }, /*#__PURE__*/ React.createElement(MuiIconButton, {
        id: "closeIconBtn",
        onClick: handleClose,
        disabled: isLoaderOpen,
        style: {
            marginLeft: "7px"
        }
    }, /*#__PURE__*/ React.createElement("img", {
        id: "crossIcon",
        src: CrossIcon,
        alt: "settingIcon"
    })))))), isDesktop ? null : /*#__PURE__*/ React.createElement(DrawerHeader, null), loader.isLoaderOpen ? /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Loader, null)) : /*#__PURE__*/ React.createElement(React.Fragment, null), showSkeleton ? /*#__PURE__*/ React.createElement(JobItemsLoader, null) : /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2,
        paddingTop: 2
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        style: {
            display: 'flex',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ React.createElement(TextField, {
        size: "small",
        fullWidth: true,
        type: "text",
        placeholder: t("Search job items"),
        InputProps: {
            startAdornment: /*#__PURE__*/ React.createElement("img", {
                height: 20,
                width: 20,
                src: SearchIcon,
                style: {
                    marginRight: "6px"
                }
            }),
            endAdornment: searchValue.length > 0 && /*#__PURE__*/ React.createElement("img", {
                src: CrossIcon,
                id: "clear-job-items-search",
                onClick: function () {
                    setSearchValue('');
                    setSearchResult([]);
                }
            })
        },
        style: {
            width: '90%'
        },
        onChange: onChange,
        id: "searchTranslateToJob",
        value: searchValue
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        paddingBottom: 10
    }, searchValue.length >= 3 && !loader.isLoaderOpen && searchResult.length === 0 ? /*#__PURE__*/ React.createElement(MuiStack, {
        height: '70vh',
        paddingTop: 2,
        justifyContent: 'center',
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: 'lg',
            fontWeight: 'normal',
            color: 'text.primary'
        }
    }, t("No result found"))) : /*#__PURE__*/ React.createElement(React.Fragment, null, listValue === null || listValue === void 0 ? void 0 : listValue.map(function (item, index) {
        var existInSearch = searchResult.find(function (searchItem) { return searchItem.ComplaintGroupId === item.id; });
        if (searchValue.length >= 3) {
            if (!existInSearch) {
                return /*#__PURE__*/ React.createElement(React.Fragment, null);
            }
        }
        return /*#__PURE__*/ React.createElement(Accordion, {
            key: index + 1,
            expanded: expanded === item.id,
            onChange: handleChange(item.id),
            sx: {
                gap: '16px',
                borderRadius: 0
            }
        }, /*#__PURE__*/ React.createElement(AccordionSummary, {
            expandIcon: /*#__PURE__*/ React.createElement(ExpandMoreIcon, {
                id: "expandMoreIcon",
                sx: {
                    fontSize: '1.5rem'
                }
            }),
            onClick: function () { return handleAccordian(item.id, index, expanded === item.id); }
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "itemTypeName",
            sx: {
                fontSize: 'lg',
                fontWeight: 'normal',
                color: 'text.primary'
            }
        }, item === null || item === void 0 ? void 0 : item.DisplayName), (item === null || item === void 0 ? void 0 : item.selectedValueCount) > 0 && /*#__PURE__*/ React.createElement(Chip, {
            id: "totalItemCount",
            label: (item === null || item === void 0 ? void 0 : item.selectedValueCount) || 0,
            color: "primary",
            variant: "filled",
            shape: "circular",
            sx: {
                ml: '10px'
            }
        })), /*#__PURE__*/ React.createElement(AccordionDetails, {
            sx: {
                padding: 2,
                paddingTop: 0,
                '& .MuiAccordionDetails-root': {
                    '& .css-cwppp': {
                        borderRadius: '8px'
                    }
                }
            }
        }, /*#__PURE__*/ React.createElement(CheckBoxComponent, {
            itemsList: item.data,
            searchedItems: existInSearch !== null && existInSearch !== void 0 && existInSearch.GetComplaints ? existInSearch === null || existInSearch === void 0 ? void 0 : existInSearch.GetComplaints : [],
            valueExpr: "ComplaintId",
            groupItem: item.Name,
            onChange: handleCheckBoxClick,
            searchValue: searchValue,
            isDisabled: isDisabled,
            isSkeletonVisible: item.isSkeletonVisible,
            filterSystemName: filterSystemName,
            ComplaintGroupId: item.id
        })));
    }))), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        position: "sticky",
        right: 0,
        bottom: 0,
        spacing: 1,
        bgcolor: "#FFFFFF",
        padding: 2,
        margin: 0
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 6,
        md: 6,
        lg: 6
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "trnaslateToJobCancel",
        size: "medium",
        name: t('Cancel'),
        style: {
            border: '1px solid #DEE4EB',
            color: '#6A7682'
        },
        fullWidth: true,
        onClick: handleClose
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 6,
        md: 6,
        lg: 6
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        loading: loader.isLoaderOpen,
        id: "trnaslateToJobSave",
        size: "medium",
        name: t('Save'),
        variant: "contained",
        fullWidth: true,
        onClick: handleSave,
        disabled: !isSaveDisbale || isDisabled
    }))))));
}
